import { render, staticRenderFns } from "./AdminMarketingJobs.vue?vue&type=template&id=095e4ad0"
import script from "./AdminMarketingJobs.vue?vue&type=script&lang=js"
export * from "./AdminMarketingJobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports